import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';

// Nota: le due sezioni di testimonianze previste dal copy (dopo la barra di
// prova sociale e dopo la trasformazione) non sono in pagina: restano fuori
// finché non ci sono citazioni reali di coach da pubblicare.

export function App() {
  return <div className="min-h-screen w-full bg-cream text-ink font-sans selection:bg-sage selection:text-white" data-id="element-0" data-mp="3ijpcuzwkmx98">
      <MetaPixel data-id="element-1" data-mp="3mjg93j4va5l5" />
      <main data-id="element-2" data-mp="3rc9ca2kot5v4">
        <Hero data-id="element-3" data-mp="3rbr9so7flver" />
        <SocialProofBar data-id="element-4" data-mp="3rbzq6q2rjiup" />
        <PainGrid data-id="element-5" data-mp="3rcswjpxt86cb" />
        <BigIdea data-id="element-6" data-mp="3reccfffk0fdk" />
        <ProductReveal data-id="element-7" data-mp="5yhupa6n3cr" />
        <Tomes data-id="element-8" data-mp="67yhm9c7y5s" />
        <Bonuses data-id="element-9" data-mp="4n4bxqxqh8g" />
        <Urgency data-id="element-10" data-mp="56nfhsbnbo2" />
        <Pricing data-id="element-11" data-mp="7su7f7e1n58" />
        <Transformation data-id="element-12" data-mp="2zld1d7i6tbah" />
        <Guarantee data-id="element-13" data-mp="2zlv8iz6e19x6" />
        <Faq data-id="element-14" data-mp="2zmem63p09c5e" />
        <CostOfInaction data-id="element-15" data-mp="2zmwggus3xgao" />
        <Close data-id="element-16" data-mp="33mov9p83gioh" />
      </main>
      <Footer data-id="element-17" data-mp="33lwyib2rgewm" />
    </div>;
}